import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'

import auth from '../../services/auth/auth'
import { isAdmin } from '../../utils/adminUtils'

// Authentication guard
export const requireAuth = (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext
) => {
  if (!auth.isAuthenticated()) {
    // Save the original URL including query parameters
    const targetUrl = to.fullPath
    next({
      path: '/login',
      query: { redirect: targetUrl }
    })
  } else {
    next()
  }
}

// Already authenticated guard (for login page)
export const redirectIfAuth = (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext
) => {
  if (auth.isAuthenticated()) {
    // Check for redirect query parameter first
    const redirectPath = to.query.redirect as string
    if (redirectPath) {
      next({ path: redirectPath })
    } else {
      // Check sessionStorage for saved redirect (from OAuth flow)
      const savedRedirect = sessionStorage.getItem('authentik_redirect_to')
      if (savedRedirect) {
        sessionStorage.removeItem('authentik_redirect_to')
        next({ path: savedRedirect })
      } else {
        next({ path: '/' })
      }
    }
  } else {
    next()
  }
}

// Admin guard - requires authentication and admin privileges
// export const requireAdmin = (
//   to: RouteLocationNormalized,
//   from: RouteLocationNormalized,
//   next: NavigationGuardNext
// ) => {
//   if (!auth.isAuthenticated()) {
//     // Save the original URL including query parameters
//     const targetUrl = to.fullPath
//     next({
//       path: '/login',
//       query: { redirect: targetUrl }
//     })
//     return
//   }

//   const user = auth.getUser()
//   if (!isAdmin(user)) {
//     // Redirect to home page if not admin
//     next({ path: '/' })
//     return
//   }

//   next()
// }
